import { ChipRootProps } from '@heroui/react/chip';
import React from 'react';
import { Badge } from 'src/design-system';

interface CompendiumBetaBadgeProps {
  className?: string;
  variant?: ChipRootProps['variant'];
  active?: boolean;
}

const CompendiumBetaBadge: React.FC<CompendiumBetaBadgeProps> = ({
  className,
  variant = 'soft',
  active = false
}) => (
  <Badge
    color={active ? 'default' : 'accent'}
    variant={variant}
    size="sm"
    className={`h-5 px-2 text-[0.625rem] font-semibold uppercase tracking-wide ${className ?? ''}`.trim()}>
    Beta
  </Badge>
);

export default CompendiumBetaBadge;
